import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import Highcharts from 'highcharts';
import { DrillDown } from '@shared/services/logs/logs.service';
import { HighchartsChartModule } from 'highcharts-angular';
import { HighChartsI18n } from '@shared/components/highcharts/i18n';

@Component({
  selector: 'app-donut',
  templateUrl: './donut.component.html',
  styleUrls: ['./donut.component.scss'],
  imports: [HighchartsChartModule],
})
export class DonutComponent implements OnChanges {
  @Input() data: Highcharts.Options;
  @Input() fontSize: string = '14px';
  @Input() title: string = '';
  @Input() print = false;

  @Output() sliceClicked = new EventEmitter<DrillDown>();

  Highcharts: typeof Highcharts = Highcharts;
  options: Highcharts.Options;

  constructor(private readonly i18n: HighChartsI18n) {}

  async ngOnInit() {
    if (!this.options) {
      this.buildOptions();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.data?.currentValue) {
      return;
    }

    this.buildOptions();
  }

  buildOptions() {
    if (!this.data) {
      return;
    }

    const self = this;
    this.options = { ...this.data };

    this.options.title = {
      y: 20,
      align: 'center',
      text: this.title,
      style: {
        fontSize: this.fontSize,
      },
    };

    this.options.credits = { enabled: false };

    this.options.lang = this.i18n.langOptions;
    this.options.lang.noData = '';

    if (!this.options.series) {
      this.options.exporting = { enabled: false };
      return;
    }

    this.options.legend.events = {
      itemClick: function(event) {
        const point = event.legendItem as unknown as DrillDown;
        setTimeout(() => self.sliceClicked.emit(point), 0);
        return false;
      },
    };

    this.options.plotOptions.pie.cursor = 'pointer';
    this.options.plotOptions.pie.point.events.click = (event) =>
      this.sliceClicked.emit(event.point as unknown as DrillDown);

    this.options.plotOptions.series.animation = false;
  }
}
